import jwt_decode from "jwt-decode";

type DecodedTokenType = {
  exp: number;
  iat: number;
};

export function validateToken(token: string) {
  const decodedToken = jwt_decode(token) as DecodedTokenType | null;
  const refreshToken = localStorage.getItem("refresh_token");
  const decodedRefreshToken = refreshToken
    ? (jwt_decode(refreshToken) as DecodedTokenType | null)
    : null;

  if (!decodedToken || !decodedRefreshToken) return false;

  return (
    decodedToken?.exp > Date.now() / 1000 ||
    decodedRefreshToken?.exp > Date.now() / 1000
  );
}
